import React, { useEffect, useRef, useState } from 'react';

import Alert from './01_atoms/Alert/Alert';
import { AlertType } from '../types/AlertTypes';

function Alerts() {
  // Alerts
  const [labelAlert, setLabelAlert] = useState('');
  const [typeAlert, setTypeAlert] = useState<AlertType>('Success');
  const [showAlert, setShowAlert] = useState(false);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  // Define stable handler functions outside the effect
  const onShowAlert = useRef((e: Event) => {
    const customEvent = e as CustomEvent;
    setLabelAlert(customEvent.detail.label);
    setTypeAlert(customEvent.detail.type);
    setShowAlert(true);

    // Clear any existing timeout
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    // Set new timeout and store its id
    timeoutIdRef.current = setTimeout(() => {
      setShowAlert(false);
      timeoutIdRef.current = null;
    }, 5000);
  }).current;

  const onCloseAlert = useRef((e: Event) => {
    const customEvent = e as CustomEvent;
    setShowAlert(customEvent.detail.showAlert);

    // Clear timeout if alert is being closed
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
  }).current;

  useEffect(() => {
    window.addEventListener('ShowAlert', onShowAlert);
    window.addEventListener('CloseAlert', onCloseAlert);

    return () => {
      // Remove event listeners with same references
      window.removeEventListener('ShowAlert', onShowAlert);
      window.removeEventListener('CloseAlert', onCloseAlert);

      // Clear timeout on unmount
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [onShowAlert, onCloseAlert]);

  return showAlert ? <Alert label={labelAlert} type={typeAlert} /> : null;
}

export default Alerts;